import { Flex, Icon, Stack, Text } from '@chakra-ui/react';
import { isEmpty, omitBy } from 'lodash';
import { useCallback } from 'react';
import DatePicker from 'react-date-picker';
import { BiCalendar, BiX } from 'react-icons/bi';

import { formatDate, SERVER_DATE_FORMAT, UI_DATE_FORMAT } from '../../utils/dateUtils';
import { parseFilterStringToObject } from './filterUtils';

export interface DateFilterValue {
    from?: string;
    to?: string;
}
export const DateFilter = ({
    filterValue,
    setFilterValue,
}: {
    filterValue: string | undefined;
    setFilterValue: (value?: string) => void;
}) => {
    const parsedValue = filterValue ? (parseFilterStringToObject(filterValue) as DateFilterValue) : undefined;

    const onChange = useCallback(
        (change: DateFilterValue) => {
            const merged = omitBy(
                {
                    ...parsedValue,
                    ...change,
                },
                isEmpty,
            );

            const newValue = Object.keys(merged).length ? encodeURIComponent(JSON.stringify(merged)) : undefined;
            setFilterValue(newValue);
        },
        [parsedValue, setFilterValue],
    );

    return (
        <Stack gap={1}>
            <Flex alignItems="center">
                <Text w="100px">From</Text>
                <DatePicker
                    format={UI_DATE_FORMAT}
                    onChange={(value) =>
                        onChange({ from: value ? formatDate(value as Date, SERVER_DATE_FORMAT) : undefined })
                    }
                    value={parsedValue?.from}
                    clearIcon={<Icon as={BiX} />}
                    calendarIcon={<Icon as={BiCalendar} />}
                    shouldCloseCalendar={() => true}
                />
            </Flex>
            <Flex alignItems="center">
                <Text w="100px">To</Text>
                <DatePicker
                    format={UI_DATE_FORMAT}
                    onChange={(value) =>
                        onChange({ to: value ? formatDate(value as Date, SERVER_DATE_FORMAT) : undefined })
                    }
                    value={parsedValue?.to}
                    clearIcon={<Icon as={BiX} />}
                    calendarIcon={<Icon as={BiCalendar} />}
                    shouldCloseCalendar={() => true}
                />
            </Flex>
        </Stack>
    );
};
